module.exports = __webpack_public_path__ + "static/media/new-indexLogo-text.59feeb9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/irontrade/new-indexLogo-text.svg
// module id = 1238
// module chunks = 103